const Cover = ({ image }) => {
    return (
        image
    );
};

export default Cover;
